<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-6">
    </base-header>

    <div class="container-fluid mt--7">
      <form role="form" v-on:submit="search">
        <div class="search row">
          <div class="dropdown"></div>
          <div class="col-lg-4 pt-0 pl-0 pr-2">
            <base-input
              alternative=""
              label=""
              placeholder="ข้อมูลที่ต้องการค้นหา"
              input-classes="form-control-alternative"
              v-model="keyword"
            />
          </div>
          <input
            type="submit"
            class="btn btn-primary mt--2 mt-md-0 mb-md-4"
            value="ค้นหาข้อมูล"
          />
        </div>
      </form>
      <div class="row">
        <div class="col">
          <employee-table
            title="พนักงานทั้งหมด"
            :employees="employees"
          ></employee-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import EmployeeTable from "./Tables/EmployeeTable";
import kickMixin from "../mixins/kickMixin";

export default {
  name: "employee",
  mixins: [kickMixin],
  components: {
    EmployeeTable,
  },
  data() {
    return {
      keyword: "",
      employees: [],
    };
  },
  methods: {
    loadEmployees: function() {
      var localApp = this;
      axios
        .get("/api/employee", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then(function(response) {
          localApp.employees = response.data.data;
        })
        .catch(function() {
          localApp.kick();
        });
    },
    search: async function(e) {
      let localApp = this;
      e.preventDefault();

      await axios
        .get(
          "/api/employee/search/q?keyword=" +
            localApp.keyword,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then(function(response) {
          localApp.employees = response.data.data;
        })
        .catch(function(error) {
          alert(error);
        });
    },
  },
  created: function() {
    if (!localStorage.token) {
      this.kick();
    } else {
      this.loadEmployees();
    }
  },
};
</script>
<style>
.search {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
a {
  cursor: pointer;
}
</style>
